export default "__VITE_ASSET__C_Ck3R7x__"